// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"last-step-published_wrapper__2mSr5","title":"last-step-published_title__3tuuU","desc":"last-step-published_desc__3O6Wb"};